<template>
<div>
  <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18" class="main-container">
  <!-- <img :src="broker_list[0].logo"> -->
    <el-col v-if="steps === 1" :span="24" class="broker-list-container">
      <component :is="currentComponent" :registration_email="registration_email" :data="ruleForm"></component>
    </el-col>
    <el-col v-else :span="24" class="broker-list-container" style="  margin-bottom: 40px;float: none;">

      <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14" class="form-container">
        <el-col :span="24" class="card-header" style="text-align: center; padding-bottom: 40px;">
          <img v-if="current_logo" :src="current_logo" class="logo-container">
          <a v-else href="https://www.smartcharts.net/" class="smartchart-logo"><object :data="smartchart_logo" type="image/svg+xml"></object></a>
          <!-- <h1>Register</h1> -->
          <!-- <p class="page-subtitle">At SmartCharts we are committed to providing you with the best trading experience we can. That's why we have put together a list of brokers that are now compatible with SmartCharts live accounts. Simply choose the broker that you want to use, apply for a Live account and we'll sync it to your SmartCharts subscription so you can use it inside SmartCharts!</p>-->
        </el-col>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :label-position="position" label-width="120px">
          <el-col :span="24">
            <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
              <el-form-item label="First Name" prop="firstname">
                <el-input v-model="ruleForm.firstname" size="medium" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
              <el-form-item label="Last Name" prop="lastname">
                <el-input v-model="ruleForm.lastname" size="medium" clearable></el-input>
              </el-form-item>

            </el-col>
          </el-col>

          <el-form-item id="dob-form-item" label="Date of Birth" required>
            <!-- <el-input :value="dateOfBirth" clearable @input="formatDate($event)" placeholder="YYYY-MM-DD"></el-input> -->
            <input class="dob-input" type="text" :value="ruleForm.dob" size="medium"  clearable @input="formatDate($event)" placeholder="DD/MM/YYYY">

          </el-form-item>

          <!--  <el-date-picker v-model="ruleForm.dob" type="date" placeholder="Pick a date" default-value="2010-10-01" class="date-pick">
            </el-date-picker> -->

          <el-form-item label="Email" prop="email" required>
            <el-input v-model="ruleForm.email" clearable size="medium" ></el-input>
          </el-form-item>

          <el-form-item label="Phone" prop="phone" required>
            <el-input v-model="ruleForm.phone" clearable size="medium" ></el-input>
          </el-form-item>

          <el-form-item label="Password" prop="pass" required>
            <el-input type="password" v-model="ruleForm.pass" size="medium" autocomplete="off" @input="checkInputLength" clearable></el-input>
          </el-form-item>
          <el-col :span="24" style="padding-left: 125px; padding-bottom: 30px;padding-top:0px;" class="password-str">
            <el-col :span="8" id="1st" class="steps" :class="password_score > 0 ? 'red_' : 'grey_'"></el-col>
            <el-col :span="8" id="2nd" class="steps" :class="password_score > 1 ? 'yellow_' : 'grey_'"></el-col>
            <el-col :span="8" id="3rd" class="steps" :class="password_score > 2 ? 'green_' : 'grey_'"></el-col>
          </el-col>
          <el-col :span="24" style="  padding-left: 125px;margin-top: -20px;padding-bottom: 20px;" class="password-str">
            <el-col :span="12" :class="char_length === true ? 'green_text' : 'grey_text'">
              <i v-if="char_length" class="el-icon-success"></i>
              <i v-else class="el-icon-circle-close"></i>
              At least 8 characters
            </el-col>
            <el-col :span="12" :class="char_capital === true ? 'green_text' : 'grey_text'">
              <i v-if="char_capital" class="el-icon-success"></i>
              <i v-else class="el-icon-circle-close"></i>
              At least 1 capital letter
            </el-col>
            <el-col :span="12" :class="char_number === true ? 'green_text' : 'grey_text'">
              <i v-if="char_number" class="el-icon-success"></i>
              <i v-else class="el-icon-circle-close"></i>
              At least 1 number
            </el-col>
            <el-col :span="12" :class="char_symbol === true ? 'green_text' : 'grey_text'">
              <i v-if="char_symbol" class="el-icon-success"></i>
              <i v-else class="el-icon-circle-close"></i>

              At least 1 symbol
            </el-col>
          </el-col>
          <el-form-item label="Confirm" prop="checkPass" required>
            <el-input type="password" v-model="ruleForm.checkPass" size="medium" autocomplete="off" clearable></el-input>
          </el-form-item>
          <div v-if=existing_brooker>
            <el-divider class="custom-divider"></el-divider>
            <el-form-item label="Live Trading Account number" prop="" required label-width="210px">
              <el-tooltip class="item tool-tip-custom" effect="dark" content="this is the account number of the live account that you want to use with SmartCharts" placement="top-start">
                <i class="el-icon-info icon-info-cus"></i>
              </el-tooltip>
              <el-input type="text" v-model="trading_id" size="medium" autocomplete="off" clearable class="input-tradind-id"></el-input>
            </el-form-item>

            <el-form-item label="Trading Email" prop="" label-width="210px">
              <el-tooltip class="item tool-tip-custom" effect="dark" content="Tell us the email address the account with your broker uses, if it is different to the one used above." placement="top-start">
                <i class="el-icon-info icon-info-cus"></i>
              </el-tooltip>
              <el-input type="text" style="  margin-left: 20px;  width: calc(100% - 20px);" v-model="trading_account_email" size="medium" autocomplete="off" clearable></el-input>
            </el-form-item>

            <!-- <el-form-item label="Brooker" prop="">
              <el-input type="text" v-model="existing_brooker" disabled autocomplete="off" clearable></el-input>
            </el-form-item> -->
          </div>


          <!-- ###### -->
          <div style="text-align: center">
            <div><span style="font-size: 10px;padding-bottom: 10px;display: block;padding-top: 10px;color: rgba(255, 255, 255, .6);">POWERED BY</span></div>
            <a href="https://www.smartcharts.net/" class="smartchart-logo"><object :data="smartchart_logo" type="image/svg+xml"></object></a>
          </div>

        </el-form>
        <el-col :span="24" class="card-footer">
          <el-col :span="12" style="text-align: left;">
            <el-dropdown>
              <el-button type="primary">

                <div v-if="active_lang === 'en'" class="drop-down-main">
                  <img src="https://login.smartcharts.xyz/img/flags/4x3/gb.svg" class="flag" />British English
                </div>
                <div v-else class="drop-down-main">
                  <img src="https://login.smartcharts.xyz/img/flags/4x3/tr.svg" class="flag" />Türk
                </div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><img src="https://login.smartcharts.xyz/img/flags/4x3/gb.svg" class="flag" />British English</el-dropdown-item>
                <el-dropdown-item><img src="https://login.smartcharts.xyz/img/flags/4x3/tr.svg" class="flag" />Türk</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <el-button v-loading="loading" size="large" @click="handleRegister('ruleForm')" type="success">Register</el-button>
          </el-col>
        </el-col>

      </el-col>

    </el-col>

  </el-col>
</div>
</template>

<script>
/* eslint-disable */
// import DataComponent from "./DataComponent.vue";
import ThankYouComponent from "./ThankYouComponent.vue";
export default {
  name: "SignUp",
  components: {
    // DataComponent
    ThankYouComponent
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('Password don\'t match!'));
      } else {
        callback();
      }
    };
    return {
      registration_email: '',
      steps: 0,
      dateOfBirth: '',
      smartchart_logo: require('@/assets/logo.svg'),
      
      position: 'right',
      isMobile: false,
      currentComponent: null,
      value1: '',
      active_lang: 'en',
      char_length: false,
      char_number: false,
      char_capital: false,
      char_symbol: false,
      password_score: 0,
      ruleForm: {
        firstname: '',
        lastname: '',
        dob: '',
        email: '',
        phone: '',
        pass: '',
        checkPass: ''
      },
      trading_id: '',
      trading_account_email: '',
      existing_brooker: '',
      rules: {
        firstname: [{
            required: true,
            message: 'Please input First Name',
            trigger: 'blur'
          },
          // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
        ],
        lastname: [{
            required: true,
            message: 'Please input Last Name',
            trigger: 'blur'
          },
          // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
        ],
        // firstname: [
        //   { required: true, message: 'Please input First Name', trigger: 'blur' },
        //   { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
        // ],
        dob: [{
          type: 'date',
          required: true,
          message: 'Please pick a date',
          trigger: 'change'
        }],
        email: [{
          type: 'email',
          required: true,
          message: 'Incorrect Email',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          message: 'Please enter Phone',
          trigger: 'change'
        }],
        pass: [{
          validator: validatePass,
          trigger: 'blur'
        }],
        checkPass: [{
          validator: validatePass2,
          trigger: 'blur'
        }],
        // region: [
        //   { required: true, message: 'Please select Activity zone', trigger: 'change' }
        // ],
        // date1: [
        //   { type: 'date', required: true, message: 'Please pick a date', trigger: 'change' }
        // ],
        // date2: [
        //   { type: 'date', required: true, message: 'Please pick a time', trigger: 'change' }
        // ],
        // type: [
        //   { type: 'array', required: true, message: 'Please select at least one activity type', trigger: 'change' }
        // ],
        // resource: [
        //   { required: true, message: 'Please select activity resource', trigger: 'change' }
        // ],
        // desc: [
        //   { required: true, message: 'Please input activity form', trigger: 'blur' }
        // ]
      },
      loading: false,
      current_broker: '',
      other_broker: [],
      available_broker: [],
      current_logo: '',
     broker_list: [{
          id: '1',
          logo: require('@/assets/logo_collections/CI_logo.webp'),
          name: 'capitalindex',
          current_account: '243678',
          status: 'Active',
          type: 'current',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '2',
          logo: require('@/assets/logo_collections/sc_logo_white.webp'),
          name: 'smartcharts',
          current_account: '213352',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '3',
          logo: require('@/assets/logo_collections/errante_logo.webp'),
          name: 'Errante',
          current_account: '213352',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '4',
          logo: require('@/assets/logo_collections/tickmill.webp'),
          name: 'Tickmill',
          current_account: '989721',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '5',
          logo: require('@/assets/logo_collections/ic_markets.webp'),
          name: 'Markets',
          current_account: '215543',
          status: 'Pending',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '6',
          logo: require('@/assets/logo_collections/pepperstone.webp'),
          name: 'Pepperstone',
          current_account: '123700',
          status: 'Pending',
          type: 'available',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: false,
            indices: false,
          }
        },
        {
          id: '7',
          logo: require('@/assets/logo_collections/vt_markets.webp'),
          name: 'vt markets',
          current_account: '123701',
          status: 'Pending',
          type: 'available',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '8',
          logo: require('@/assets/logo_collections/think_markets.png'),
          name: 'Think Markets',
          current_account: '213353',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '9',
          logo: require('@/assets/logo_collections/markets_com.png'),
          name: 'Markets.com',
          current_account: '813357',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '10',
          logo: require('@/assets/logo_collections/intertrader.png'),
          name: 'InterTrader',
          current_account: '813358',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
      ]

    }
  },
  mounted() {

    if (this.$cookies.get('web_session_id')) {
      this.$router.push('/manage');
    }

    const bParam = this.$route.query.b
    if(bParam) {
      this.getLogo()
    }

    // this.sterilizeData()
    this.checkUrl()

    this.updateSize();
    window.addEventListener('resize', this.updateSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);
  },
  methods: {
    getLogo() {
     const bParam = this.$route.query.b
      ? this.$route.query.b.toLowerCase().replace(/\s+/g, '')
      : ''

    const matchedBroker = this.broker_list.find(broker => {
      const normalizedName = broker.name.toLowerCase().replace(/\s+/g, '')
      return normalizedName === bParam
    })

    if (matchedBroker) {
      this.current_logo = matchedBroker.logo
    }
    },
    formatDate(event) {
      let input = event.target;
      let raw = input.value.replace(/\D/g, '').slice(0, 8); // Only take up to 8 digits

      let day = '';
      let month = '';
      let year = '';
      let formatted = '';

      if (raw.length >= 2) {
        day = raw.slice(0, 2);
        if (parseInt(day, 10) > 31) day = '31';
      } else {
        day = raw;
      }

      if (raw.length >= 4) {
        month = raw.slice(2, 4);
        if (parseInt(month, 10) > 12) month = '12';
      } else if (raw.length > 2) {
        month = raw.slice(2);
      }

      if (raw.length > 4) {
        year = raw.slice(4, 8); // Explicitly restrict year to 4 digits max
      }

      if (raw.length <= 2) {
        formatted = day;
      } else if (raw.length <= 4) {
        formatted = `${day}/${month}`;
      } else {
        formatted = `${day}/${month}/${year}`;
      }

      this.ruleForm.dob = formatted;
      input.value = formatted; // Update the actual input field too
    },
    updateSize() {
      this.isMobile = window.innerWidth <= 767;
      if (this.isMobile) {
        this.position = 'top'
      }
    },
    checkUrl() {
      const brooker = this.$route.query.b;
      console.log('Value of b:', brooker);
      this.existing_brooker = brooker
    },
    checkInputLength() {
      this.password_score = 0
      if (this.ruleForm.pass.length > 8) {
        this.char_length = true;
        this.password_score = this.password_score + 1
      } else {
        this.char_length = false;
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }

      }

      const hasNumber = /\d/;
      if (hasNumber.test(this.ruleForm.pass)) {
        this.char_number = true;
        this.password_score = this.password_score + 1
      } else {
        this.char_number = false;
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }
      }

      const hasCapitalLetter = /[A-Z]/;
      if (hasCapitalLetter.test(this.ruleForm.pass)) {
        this.char_capital = true
        this.password_score = this.password_score + 1
      } else {
        this.char_capital = false
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }
      }

      const hasSymbol = /[^a-zA-Z0-9]/;
      if (hasSymbol.test(this.ruleForm.pass)) {
        this.char_symbol = true
        this.password_score = this.password_score + 1
      } else {
        this.char_symbol = false
        if (this.password_score > 1) {
          this.password_score = this.password_score - 1
        }
      }
    },
    // handleChooseBrooker(brooker) {
    //   console.log(brooker, 'broler')
    //   let broker_list = this.broker_list
    //   broker_list.forEach((item, index) => {
    //     item.status = 'Active'
    //     if (item.id === brooker.id) {
    //       item.status = 'selected'
    //       this.ruleForm['broker'] = item
    //     }
    //   })
    //   this.broker_list = broker_list
    // },
    handleRegister(formName) {
      this.loading = true
      if (this.existing_brooker) {
        this.ruleForm.trading_id = this.trading_id
        this.ruleForm.trading_account_email = this.trading_account_email
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.char_length && this.char_number && this.char_capital && this.char_symbol) {

          }

          var axios = require('axios');
          var data = JSON.stringify({
            "first_name": this.ruleForm.firstname,
            "last_name": this.ruleForm.lastname,
            "email": this.ruleForm.email,
            "mobile": this.ruleForm.phone,
            "password": this.ruleForm.pass,
            "dob": this.ruleForm.dob,
            "account_id": this.ruleForm.trading_id || '',
            "trading_account_email": this.ruleForm.trading_account_email,
            "broker": this.existing_brooker,
          });

          var url = process.env.VUE_APP_API_URL + '/v1/sign-up'

          this.axios
            .post(url, data, {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                withCredentials: true
              },
            })
            .then((response) => {
              if (response.status === 200) {
                this.steps = 1
                this.loading = false
                this.registration_email = this.ruleForm.email
                this.currentComponent = ThankYouComponent
              } else {
                console.log('error')
              }
            })
            .catch((error) => {
              console.log("error", error);
              this.$notify.error({
                title: 'Error',
                message: error.response.data
              });
              this.loading = false
            });

        } else {
          console.log('error submit!!');
          // alert('Invalid password')
          this.$notify.error({
            title: 'Error',
            message: 'Invalid Password'
          });
          this.loading = false
          return false;
        }
      });
    },
    onSubmit() {
      console.log('submit!');
    },
    // handleSwitch(data) {
    //   let data_list = this.broker_list
    //   data_list.forEach((item, i) => {
    //     if (item.type === 'current') {
    //       item.type = 'other'
    //     }
    //     if (item.id === data.id) {
    //       item.type = 'current'
    //     }
    //   })
    //   this.sterilizeData(data_list)
    // },
    // sterilizeData(data) {
    //   let data_list = this.broker_list
    //   if (data) {
    //     data_list = data
    //   }

    //   let current_broker = ''
    //   let other_broker = []
    //   let available_broker = []

    //   data_list.forEach((item, i) => {
    //     if (item.type === 'current') {
    //       current_broker = item
    //     } else if (item.type === 'other') {
    //       other_broker.push(item)
    //     } else {
    //       available_broker.push(item)
    //     }
    //   })

    //   this.current_broker = current_broker
    //   this.other_broker = other_broker
    //   this.available_broker = available_broker

    // }
  },
}
</script>

<style scoped>
.main-container {
  float: none !important;
  margin: 0 auto !important;
  color: #ffffff !important;
  padding-top: 10vh;
}

.broker-list-wrapper {
  text-align: left;
}

.broker-list-wrapper h2 {
  font-weight: 300;
  font-size: 22px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.broker-list-item {
  /* background-color: #3c4f6d; */
  transition: box-shadow 0.3s ease;
  background: linear-gradient(to right, #3f4f75, #3f3b5e);
  padding: 20px;
  display: flex;
  border-radius: 5px;
  height: 30px;
}

.logo_container img {
  /* width: 60px; */
  margin-left: 40px;
  width: auto;
  height: 30px;
}

.logo_container {}

.part-2 p,
.part-3 p,
.part-divider p {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-top: 5px;
}

.part-2 p {
  color: #ffffff80;
}

.part-2 p strong {
  color: #ffffff;
}

.part-divider {
  text-align: center;
  color: #ffffff3d;
}

.broker-list-item.active {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-icon {
  transform: rotate(180deg) !important;
  color: #ffffff80;
  font-size: 20px;
  margin-left: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  float: left;
  margin-top: 10px;
  margin-right: 5px;
}

.green {
  background-color: #93ca85;
}

.yellow {
  background-color: #e2ca5d;
}

.broker-list-item {
  margin-bottom: 10px;
}

.part-4 {
  float: right;
  text-align: center;

}

.broker-list-item:hover {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-btn {
  float: right;
  text-align: center;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
  padding: 5px 40px;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.item-btn:hover {
  background-color: #93ca855c;
  transition: background-color 0.3s ease;
}

.darkBlue {
  background: #283a5d !important;
  width: 13%;
  margin-right: 5px;
  display: inline-block;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.available-types-title {
  text-align: center;
  color: #ffffffb3;
}

.available-icon-true {
  border-radius: 50%;
  /* background-color: #93ca85; */
  background-color: #5a954b;
  padding: 3px;
}

.available-icon-false {
  border-radius: 50%;
  /* background-color: #ea7374; */
  background-color: #e44f51;
  font-weight: bold;
  padding: 3px;
}

.item-btn.btn-apply {
  padding: 5px 24px;
}

.available-item-check-container {
  border-right: 1px solid #ffffff3d;
  margin-top: 5px;
}

.available-item-check-container.end {
  border-right: none !important;
}

.page-subtitle {
  color: #adc0ff;
  font-size: 20px;
}

.logo-icon-container {
  margin-left: -10px;
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: -5px;
}

.available-broker-wrapper {
  padding-bottom: 10vh;
}

.available-broker-wrapper h2 {
  margin-bottom: 0px !important;
}

.broker-item-list {
  box-shadow: 1px 2px 3px #00000021;

}

.steps {
  height: 5px;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid #ffffff59;
  margin-right: 5px;
  width: 32% !important;
}

.green_ {
  background-color: #a4f14a;
  color: #a4f14a;
}

.red_ {
  background-color: #ff6c6c;
  color: #ff6c6c;
}

.yellow_ {

  background-color: #ffd077;
  color: #ffd077;
}

.green_text {
  color: #a4f14a;
}

.el-form-item__content {
  position: inherit !important;
}

#app {

  height: auto !important;
}
</style>
